import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { translationKeys } from './queryKeyFactory';
import { TranslationsResponse } from '../../Model/responseDtos/TranslationsResponse';
import { DEFAULT_RETRY_COUNT } from '../../config/consts';

export function useGetTranslations(locale?: string): UseQueryResult<TranslationsResponse, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getTranslations = () => {
    if (servicesCtx?.translationsService && locale != null) {
      return servicesCtx.translationsService.getTranslations(locale);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: translationKeys.byLocale(locale || ''),
    queryFn: getTranslations,
    retry: DEFAULT_RETRY_COUNT,
    staleTime: 1800000,
    gcTime: 1800000,
    enabled: locale != null
  });
}
